import { z } from 'zod';

export const AssignInboxToConversationSchema = z.object({
  inboxId: z.string(),
});

export const AssignLabelToConversationSchema = z.object({
  labelId: z.string(),
});

export const AssignAgentToConversationSchema = z.object({
  agentId: z.string().nullable(),
});

export const LabelSchema = z.object({
  identifier: z.string(),
  companyId: z.string(),
  labelColor: z.string(),
  labelName: z.string(),
});

export const ChatStatusSchema = z.union([
  z.literal('open'),
  z.literal('resolved'),
]);

export const HandoverHistoryTypeSchema = z.union([
  z.literal('assign'),
  z.literal('unassign'),
]);

export const ChatNotificationSchema = z.object({
  event: z.string(),
  timestamp: z.number(),
});

export const AssigneeSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  id: z.string(),
});

export const ConversationUserSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  imageUrl: z.string(),
  date: z.string().optional(),
  platform: z.string(),
  inbox: z.string().optional(),
  labels: z.array(LabelSchema.omit({ companyId: true })),
  assignedAgent: AssigneeSchema.optional(),
  status: ChatStatusSchema.optional(),
  userInfo: z
    .object({
      email: z.string().optional(),
      phone: z.string().optional(),
      address: z.string().optional(),
    })
    .optional(),
  chatNotifications: z.array(ChatNotificationSchema),
});

const HistoryMessageSchema = z.union([
  z.object({ text: z.string() }),
  z.object({
    text: z.string(),
    buttons: z.string().array(),
  }),
  z.object({
    elements: z.array(
      z.object({
        image: z.string(),
        title: z.string(),
        subtitle: z.string(),
        buttons: z.string().array(),
      }),
    ),
  }),
  z.object({ image: z.string().nullable() }),
  z.object({ image: z.string().nullable(), buttons: z.string().array() }),
  z.object({ text: z.string(), min: z.number(), max: z.number() }),
  z.object({
    type: HandoverHistoryTypeSchema,
    agent: AssigneeSchema.nullable(),
    triggeredBy: AssigneeSchema.nullable(),
  }),
]);

export const HistoryEntrySchema = z.object({
  id: z.string().nullable(),
  type: z.string(), // TODO: Make stricter
  time: z.union([z.string(), z.date()]),
  direction: z.union([z.literal('in'), z.literal('out'), z.literal('system')]),
  message: HistoryMessageSchema,
});

export const HandoverHistorySchema = z.object({
  agentId: z.string().nullable(),
  type: HandoverHistoryTypeSchema,
  triggeredBy: z.string().nullable(),
  started: z.date(),
  ended: z.union([z.date(), z.null()]),
});
